import React from 'react'

// styles
import styles from './index.module.scss'

const Selection = props => {
  const { label, data, selected, onSelect } = props

  return (
    <div className={styles.container}>
      <div className="w-full">
        <div className={styles.label}>{label}&nbsp;</div>
        <div className="flex flex-wrap gap-[15px] mt-[15px]">
          {data.map((item, index) => (
            <div
              key={index}
              className={item.name === selected ? styles.mobileSelected : styles.mobileNormal}
              onClick={() => onSelect(item)}
            >
              {item.name}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Selection
